module.exports = __webpack_public_path__ + "static/beauty-review-slider-section-code-cf9fde4b794e7d1813a8da9560d8e3e9.png";